import {
  BarChart3,
  BrainCircuit,
  Download,
  FlaskConical,
  LayoutDashboard,
  LogOut,
  Menu,
  Settings,
  Sprout,
  X,
} from "lucide-react";
import { type PropsWithChildren, useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { FilterBar } from "./FilterBar";

const navigation = [
  { to: "/", label: "Visão Geral", icon: LayoutDashboard, end: true },
  { to: "/portfolio", label: "Portfólio", icon: Sprout },
  { to: "/radar", label: "Radar", icon: FlaskConical },
  { to: "/intelligence", label: "Intelligence", icon: BrainCircuit },
  { to: "/reports", label: "Relatórios", icon: Download },
  { to: "/settings", label: "Configurações", icon: Settings },
];

export function AppShell({ children }: PropsWithChildren) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const auth = useAuth();
  return (
    <div className="app-shell">
      <aside className={`sidebar ${mobileOpen ? "sidebar--open" : ""}`}>
        <div className="brand-row">
          <div className="brand-mark">
            <Sprout size={22} />
          </div>
          <div>
            <strong>Estufa</strong>
            <span>Seed Factory</span>
          </div>
          <button
            type="button"
            className="icon-button sidebar-close"
            onClick={() => setMobileOpen(false)}
            aria-label="Fechar menu"
          >
            <X size={20} />
          </button>
        </div>
        <nav className="sidebar-nav">
          {navigation.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={() => setMobileOpen(false)}
              className={({ isActive }) => `nav-item ${isActive ? "nav-item--active" : ""}`}
            >
              <Icon size={19} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          {auth.demo ? <div className="demo-badge">Modo demonstração</div> : null}
          {!auth.demo ? (
            <button
              type="button"
              className="nav-item nav-button"
              onClick={() => void auth.signOut()}
            >
              <LogOut size={18} />
              Sair
            </button>
          ) : null}
        </div>
      </aside>
      {mobileOpen ? (
        <button
          type="button"
          className="sidebar-backdrop"
          onClick={() => setMobileOpen(false)}
          aria-label="Fechar menu"
        />
      ) : null}
      <main className="main-shell">
        <header className="topbar">
          <button
            type="button"
            className="icon-button mobile-menu"
            onClick={() => setMobileOpen(true)}
            aria-label="Abrir menu"
          >
            <Menu size={21} />
          </button>
          <div className="topbar-title">
            <BarChart3 size={19} />
            <span>Centro operacional</span>
          </div>
          <FilterBar compact />
        </header>
        <div className="mobile-filter">
          <FilterBar />
        </div>
        <div className="page-container">{children}</div>
      </main>
      <nav className="bottom-nav" aria-label="Navegação mobile">
        {navigation.slice(0, 5).map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `bottom-nav-item ${isActive ? "bottom-nav-item--active" : ""}`
            }
          >
            <Icon size={19} />
            <span>
              {label === "Intelligence" ? "Intel" : label === "Visão Geral" ? "Geral" : label}
            </span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
